/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type DeleteHolidayCalendarEntryInput = {
    id: string;
    holidayCalendarId: string;
    csrfToken?: string | null | undefined;
    socketClientId?: string | null | undefined;
    clientMutationId?: string | null | undefined;
};
export type deleteHolidayCalendarEntryMutationVariables = {
    input: DeleteHolidayCalendarEntryInput;
};
export type deleteHolidayCalendarEntryMutationResponse = {
    readonly deleteHolidayCalendarEntry: {
        readonly deletedHolidayCalendarEntryId: string | null;
    } | null;
};
export type deleteHolidayCalendarEntryMutation = {
    readonly response: deleteHolidayCalendarEntryMutationResponse;
    readonly variables: deleteHolidayCalendarEntryMutationVariables;
};



/*
mutation deleteHolidayCalendarEntryMutation(
  $input: DeleteHolidayCalendarEntryInput!
) {
  deleteHolidayCalendarEntry(input: $input) {
    deletedHolidayCalendarEntryId
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input",
    "type": "DeleteHolidayCalendarEntryInput!"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DeleteHolidayCalendarEntryPayload",
    "kind": "LinkedField",
    "name": "deleteHolidayCalendarEntry",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "deletedHolidayCalendarEntryId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "deleteHolidayCalendarEntryMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "deleteHolidayCalendarEntryMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "deleteHolidayCalendarEntryMutation",
    "operationKind": "mutation",
    "text": "mutation deleteHolidayCalendarEntryMutation(\n  $input: DeleteHolidayCalendarEntryInput!\n) {\n  deleteHolidayCalendarEntry(input: $input) {\n    deletedHolidayCalendarEntryId\n  }\n}\n"
  }
};
})();
(node as any).hash = 'b109b7c61b2d09c3704c94e992d64c2d';
export default node;
